import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

// context
import { useSearchBar } from "core/SearchBar/context/useSearchBar.js";

// components
import FormSelectDialog from "./FormSelectDialog";
import Input from "./Input";

// styles
import { convertPxToRem } from "frontend/components/helpers";
import { getBorderStyles } from "../index";

const SharedBorderBoxStyled = styled.div``;

const DropDownAndInputStyled = styled.div`
    flex: 1;
    display: flex;
    height: ${convertPxToRem(40)};

    ${({ $borderStyles }) => {
        return css`
            /* Shared Border Box */
            ${SharedBorderBoxStyled} {
                flex: 0 0 ${$borderStyles.width};
                background-color: ${$borderStyles.color};
            }

            &:hover {
                ${SharedBorderBoxStyled} {
                    background-color: ${$borderStyles.hoverColor};
                }
            }

            &:focus-within {
                ${SharedBorderBoxStyled} {
                    background-color: ${$borderStyles.focusColor};
                }
            }
        `;
    }}
`;
const InputStyled = styled(Input)`
    flex: 1;
`;

// component
export const DropDownAndInput = ({
    className,
    showFormSelectDialog = true
}) => {
    const { isDarkMode } = useSearchBar();

    return (
        <DropDownAndInputStyled
            className={className}
            $borderStyles={getBorderStyles(isDarkMode)}
        >
            {showFormSelectDialog && <FormSelectDialog />}
            <SharedBorderBoxStyled />
            <InputStyled />
        </DropDownAndInputStyled>
    );
};

export default DropDownAndInput;

// prop-types
DropDownAndInput.propTypes = {
    className: PropTypes.string,
    showFormSelectDialog: PropTypes.bool
};
